export default __webpack_public_path__ + "ac742f50199c0b6f4bbcd92089a0c410.png";